import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBubble3"><Path d="M2.98176 16.6017L2.1422 20.0701C1.88077 21.1501 2.84343 22.1295 3.92779 21.8868L7.54102 21.0779C7.6499 21.0535 7.77312 21.0662 7.89258 21.1201C9.14628 21.6856 10.5371 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5122 2.33598 14.9473 2.93783 16.2335C2.99618 16.3582 3.00931 16.4879 2.98176 16.6017Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble3;
